document.addEventListener('DOMContentLoaded', () => {
  // Avoid stopping all storefront scripts if an optional element is absent.
  const year = document.getElementById('year');
  if (year) year.textContent = new Date().getFullYear();

  // Smooth-scroll internal navigation links.
  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const targetId = link.getAttribute('href');
      if (!targetId || targetId === '#') return;
      const target = document.querySelector(targetId);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // Optional city filters, if added in the theme editor/code later.
  const filters = [...document.querySelectorAll('[data-city]')];
  const cards = [...document.querySelectorAll('[data-event-city]')];
  function setCity(city) {
    filters.forEach((button) => button.classList.toggle('active', button.dataset.city === city));
    cards.forEach((card) => card.classList.toggle('hidden', city !== 'all' && card.dataset.eventCity !== city));
  }
  filters.forEach((button) => button.addEventListener('click', () => setCity(button.dataset.city)));
  document.querySelectorAll('[data-city-link]').forEach((link) => {
    link.addEventListener('click', () => {
      setCity(link.dataset.cityLink);
      const events = document.getElementById('events');
      if (events) events.scrollIntoView({ behavior: 'smooth' });
    });
  });
});
